import type { JSX } from 'react';
import { useWorkspacePrefs } from '../hooks/useWorkspacePrefs.js';
import { resolveWorkspaceShell } from './workspaceShellRegistry.js';
import type { WorkspaceShellContentSlots, WorkspaceShellServices } from './workspaceShellTypes.js';

export function WorkspaceShellHost({ slots, services }: {
  slots: WorkspaceShellContentSlots;
  services: WorkspaceShellServices;
}): JSX.Element {
  const { prefs } = useWorkspacePrefs();
  const shell = resolveWorkspaceShell(prefs.workspaceShell);
  return (
    <div data-testid="workspace-shell-host" data-workspace-shell={shell.id} style={{ display: 'contents' }}>
      {shell.render(slots, services)}
    </div>
  );
}
